import React from "react";
import { Link } from "react-router-dom";
import {
  Anusua,
  // AmayFaculties,
  DebashisFaculties,
  Donez,
  Koushik,
  // DineshFaculties,
  KunalFaculties,
  MehebubFaculties,
  MithunImg,
  // MonjuFaculties,
  MontiFaculties,
  MousumiFaculties,
  Nandita,
  NazmaFaculties,
  PrasannaFaculties,
  // SagarFaculties,
  SouravFaculties,
  SushamFaculties,
} from "../images";

const Faculties = () => {
  return (
    <>
      <div className="breadcrumb-area d-flex  p-relative align-items-center">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-12 col-lg-12">
              <div className="breadcrumb-wrap text-center">
                <div className="breadcrumb-title">
                  <h2>Faculties</h2>
                </div>
              </div>
            </div>
            <div className="breadcrumb-wrap2">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">Faculties</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="prospectus-structure">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="main-faculties">
                <div className="faculties-img">
                  <img src={DebashisFaculties} alt="" />
                </div>
                <div className="faculties-content">
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Name</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Debashis Mondal</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Designation</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Principal</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Qualification</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: B.TECH in ME</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Experience</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 10 Years</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Department</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Principal</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Mobile No</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 9339955219</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">E-mail</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: gaatpvtiti@gmail.com</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Status</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">
                        :
                        <span
                          style={{
                            backgroundColor: "green",
                            color: "white",
                            padding: "0px 5px",
                            borderRadius: "3px",
                            marginLeft: "5px",
                          }}
                        >
                          Active
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="main-faculties">
                <div className="faculties-img">
                  <img src={MontiFaculties} alt="" />
                </div>
                <div className="faculties-content">
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Name</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Monti Das</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Designation</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Instructor & T.P.O</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Qualification</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: B.TECH in ME</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Experience</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 8 Years</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Department</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Fitter</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Mobile No</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 9339955219</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">E-mail</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: gaatpvtiti@gmail.com</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Status</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">
                        :
                        <span
                          style={{
                            backgroundColor: "green",
                            color: "white",
                            padding: "0px 5px",
                            borderRadius: "3px",
                            marginLeft: "5px",
                          }}
                        >
                          Active
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="main-faculties">
                <div className="faculties-img">
                  <img src={PrasannaFaculties} alt="" />
                </div>
                <div className="faculties-content">
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Name</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Prasanna Mondal</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Designation</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Instructor</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Qualification</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: B.TECH in ME</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Experience</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 4 Years</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Department</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Fitter</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Mobile No</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 9339955219</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">E-mail</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: gaatpvtiti@gmail.com</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Status</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">
                        :
                        <span
                          style={{
                            backgroundColor: "green",
                            color: "white",
                            padding: "0px 5px",
                            borderRadius: "3px",
                            marginLeft: "5px",
                          }}
                        >
                          Active
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="main-faculties">
                <div className="faculties-img">
                  <img src={SushamFaculties} alt="" />
                </div>
                <div className="faculties-content">
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Name</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Susham Nath</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Designation</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Instructor</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Qualification</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: B.TECH in ME</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Experience</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 4 Years</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Department</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Welder</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Mobile No</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 9339955219</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">E-mail</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: gaatpvtiti@gmail.com</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Status</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">
                        :
                        <span
                          style={{
                            backgroundColor: "green",
                            color: "white",
                            padding: "0px 5px",
                            borderRadius: "3px",
                            marginLeft: "5px",
                          }}
                        >
                          Active
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="main-faculties">
                <div className="faculties-img">
                  <img src={MehebubFaculties} alt="" />
                </div>
                <div className="faculties-content">
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Name</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Mehebub Alam</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Designation</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Instructor</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Qualification</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: B.TECH in EE</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Experience</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 4 Years</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Department</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Electrician</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Mobile No</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 9339955219</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">E-mail</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: gaatpvtiti@gmail.com</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Status</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">
                        :
                        <span
                          style={{
                            backgroundColor: "red",
                            color: "white",
                            padding: "0px 5px",
                            borderRadius: "3px",
                            marginLeft: "5px",
                          }}
                        >
                          In Active
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="main-faculties">
                <div className="faculties-img">
                  <img src={SouravFaculties} alt="" />
                </div>
                <div className="faculties-content">
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Name</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Sourav Shaw</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Designation</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Instructor</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Qualification</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: B.TECH in ME</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Experience</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 3 Years</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Department</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Fitter</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Mobile No</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 9339955219</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">E-mail</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: gaatpvtiti@gmail.com</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Status</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">
                        :
                        <span
                          style={{
                            backgroundColor: "green",
                            color: "white",
                            padding: "0px 5px",
                            borderRadius: "3px",
                            marginLeft: "5px",
                          }}
                        >
                          Active
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="main-faculties">
                <div className="faculties-img">
                  <img src={NazmaFaculties} alt="" />
                </div>
                <div className="faculties-content">
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Name</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Nazma Parvin</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Designation</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Instructor</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Qualification</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: B.TECH in EE</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Experience</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 3 Years</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Department</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Electrician</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Mobile No</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 9339955219</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">E-mail</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: gaatpvtiti@gmail.com</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Status</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">
                        :
                        <span
                          style={{
                            backgroundColor: "red",
                            color: "white",
                            padding: "0px 5px",
                            borderRadius: "3px",
                            marginLeft: "5px",
                          }}
                        >
                          In Active
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="main-faculties">
                <div className="faculties-img">
                  <img src={KunalFaculties} alt="" />
                </div>
                <div className="faculties-content">
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Name</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Kunal Ghosh</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Designation</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Instructor</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Qualification</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: B.TECH in EE</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Experience</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 4 Years</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Department</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Electrician</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Mobile No</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 9339955219</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">E-mail</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: gaatpvtiti@gmail.com</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Status</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">
                        :
                        <span
                          style={{
                            backgroundColor: "green",
                            color: "white",
                            padding: "0px 5px",
                            borderRadius: "3px",
                            marginLeft: "5px",
                          }}
                        >
                          Active
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="main-faculties">
                <div className="faculties-img">
                  <img src={MousumiFaculties} alt="" />
                </div>
                <div className="faculties-content">
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Name</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Mousumi Ghosh</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Designation</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Instructor</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Qualification</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: MA in English, B.ED</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Experience</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 4 Years</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Department</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: English</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Mobile No</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 9339955219</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">E-mail</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: gaatpvtiti@gmail.com</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Status</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">
                        :
                        <span
                          style={{
                            backgroundColor: "green",
                            color: "white",
                            padding: "0px 5px",
                            borderRadius: "3px",
                            marginLeft: "5px",
                          }}
                        >
                          Active
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="main-faculties">
                <div className="faculties-img">
                  <img src={MithunImg} alt="" />
                </div>
                <div className="faculties-content">
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Name</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Mithun Mondal</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Designation</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Workshop Instructor</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Qualification</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Diploma in EE</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Experience</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 2 Years</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Department</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Electrician</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Mobile No</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 9339955219</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">E-mail</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: gaatpvtiti@gmail.com</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Status</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">
                        :
                        <span
                          style={{
                            backgroundColor: "green",
                            color: "white",
                            padding: "0px 5px",
                            borderRadius: "3px",
                            marginLeft: "5px",
                          }}
                        >
                          Active
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="main-faculties">
                <div className="faculties-img">
                  <img src={Anusua} alt="" />
                </div>
                <div className="faculties-content">
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Name</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Anusua Dutta</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Designation</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Instructor</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Qualification</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: B.TECH in EE</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Experience</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: NIL</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Department</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Electrician</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Mobile No</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 9339955219</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">E-mail</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: gaatpvtiti@gmail.com</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Status</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">
                        :
                        <span
                          style={{
                            backgroundColor: "green",
                            color: "white",
                            padding: "0px 5px",
                            borderRadius: "3px",
                            marginLeft: "5px",
                          }}
                        >
                          Active
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="main-faculties">
                <div className="faculties-img">
                  <img src={Koushik} alt="" />
                </div>
                <div className="faculties-content">
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Name</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Koushik Chakroborty</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Designation</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Instructor</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Qualification</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: B.TECH in EE</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Experience</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 7 Years</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Department</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Electrician</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Mobile No</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 9339955219</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">E-mail</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: gaatpvtiti@gmail.com</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Status</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">
                        :
                        <span
                          style={{
                            backgroundColor: "green",
                            color: "white",
                            padding: "0px 5px",
                            borderRadius: "3px",
                            marginLeft: "5px",
                          }}
                        >
                          Active
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="main-faculties">
                <div className="faculties-img">
                  <img src={Donez} alt="" />
                </div>
                <div className="faculties-content">
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Name</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Donez Das</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Designation</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Instructor</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Qualification</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: DIPLOMA in EE</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Experience</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: NIL</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Department</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Electrician</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Mobile No</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 9339955219</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">E-mail</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: gaatpvtiti@gmail.com</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Status</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">
                        :
                        <span
                          style={{
                            backgroundColor: "green",
                            color: "white",
                            padding: "0px 5px",
                            borderRadius: "3px",
                            marginLeft: "5px",
                          }}
                        >
                          Active
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="main-faculties">
                <div className="faculties-img">
                  <img src={Nandita} alt="" />
                </div>
                <div className="faculties-content">
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Name</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Nandita Sinha</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Designation</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Instructor</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Qualification</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Diploma in EE</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Experience</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 6 Months</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Department</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: Electrician</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Mobile No</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: 9339955219</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">E-mail</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">: gaatpvtiti@gmail.com</p>
                    </div>
                  </div>
                  <div className="faculties-div">
                    <div className="faculties-left">
                      <p className="mb-0">Status</p>
                    </div>
                    <div className="faculties-right">
                      <p className="mb-0">
                        :
                        <span
                          style={{
                            backgroundColor: "green",
                            color: "white",
                            padding: "0px 5px",
                            borderRadius: "3px",
                            marginLeft: "5px",
                          }}
                        >
                          Active
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Faculties;
